import React from 'react';

const Blank = () => <></>

export default Blank;